export default __webpack_public_path__ + "static/media/icon_union_pay.1f8b2b88.png";